function AuthLayout ({ children }) {

 return (
  <div>
  <main>
    {children}
  </main>
</div>
 )  
}

export default AuthLayout;